import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Action from "../../pages/public-applicant/_redux/recruitementActions";
import API from "../../helpers/devApi";
import { swalError, swalSuccess, swalWarning } from "../../helpers/swal";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { Progress, Space } from "antd";

export function ProfileCardPublic() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { applicantsInfo, profilePercentage } = useSelector(
    ({ publicApplicant }) => ({
      applicantsInfo: publicApplicant.applicantsInfo,
      profilePercentage: publicApplicant.profilePercentage,
    })
  );

  console.log(applicantsInfo?.profile_image, "+++");

  const [images, setImages] = useState(null);
  const [preview, setPreview] = useState(false);
  const [picture, setPicture] = useState(null);

  const handleImage = (e) => {
    const files = e.target.files[0];
    const kb = files?.size / 1024;
    if (kb > 300) {
      // 300KB
      swalWarning("Photo size must be less than 300 KB");
    } else {
      setImages(files);
      setPicture(URL.createObjectURL(files));
      dispatch(Action.updateApplicantsInfoKey({ profile_image: files }));
      setPreview(true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(Action.updateApplicantsInfoKey({ profile_image: images }));
    var formdata = new FormData();
    formdata.append("profile_image", images);
    await API.post(
      `/hrms_applicant/profile-photo-update/${user?.data?.applicant_id}`,
      formdata
    )
      .then((res) => {
        if (res?.data?.success) {
          swalSuccess("Profile photo updated successfully");
          dispatch(Action.insertProfileScore(["Profile Image"]));

          // dispatch(Action.getProfilePercentage());
          setPreview(false);
        } else {
          swalError(res?.data?.message, " ");
        }
      })
      .catch((error) => {
        swalError("someting went wrong");
      });
  };

  const DOC_CONTAINER = process.env.REACT_APP_DOC_CONTAINER;
  const DOC_TOKEN = process.env.REACT_APP_DOC_TOKEN;

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="card profile_card_main">
          <div className="left_box">
            <div className="image_box">
              {applicantsInfo?.profile_image instanceof File ? (
                <img
                  src={URL.createObjectURL(applicantsInfo?.profile_image)}
                  alt="Profile images"
                />
              ) : (
                <img src={toAbsoluteUrl("/media/users/default.jpg")} alt="" />
              )}
            </div>
            <div className="info_box">
              <h2>
                {" "}
                {`${applicantsInfo?.first_name || ""} ${
                  applicantsInfo?.middle_name || ""
                } ${applicantsInfo?.last_name || ""}`.trim()}
              </h2>
              {/* <p>{applicantsInfo?.sys_designation?.designation_name}</p> */}

              <form onSubmit={(e) => handleSubmit(e)}>
                {preview ? (
                  <>
                    <div className="row mt-10">
                      <div className="col-md-12 mb-3 text-left"></div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="avatar-upload">
                      <div className="avatar-edit">
                        <input
                          type="file"
                          id="imageUpload"
                          accept=".png, .jpg, .jpeg"
                          onChange={(e) => {
                            handleImage(e);
                          }}
                        />
                        <label
                          htmlFor="imageUpload"
                          className="profile_upload_btn"
                        >
                          <i className="fas fa-camera mr-2"></i>
                          Change photo
                        </label>
                      </div>
                    </div>
                  </>
                )}
                {/* <button 
                                        className="change_photo_btn"
                                    >
                                        <i className="fas fa-camera mr-2"></i>
                                        Change photo
                                    </button> */}
              </form>
            </div>
          </div>
          <div className="right_box">
            <Space wrap></Space>

            {/* <div className="progress blue">
                            <span className="progress-left">
                                <span className="progress-bar"></span>
                            </span>
                            <span className="progress-right">
                                <span className="progress-bar"></span>
                            </span>
                            <div className="progress-value">
                                <h3>{profilePercentage}%</h3>
                                <p>Profile <br /> Complete</p>
                            </div>
                        </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
